import React, { FC } from "react"
import { Title, TitleProps } from "dash-styled"

interface SettingsSubSectionProps {
    title: string
    titleComponent?: TitleProps["component"]
    testId?: string
}

export const SettingsSubSection: FC<SettingsSubSectionProps> = ({
    testId,
    title,
    titleComponent = "h3",
    children
}) => {
    return (
        <section
            data-testid={testId}
            className="border-t border-solid border-rhino-300 flex flex-col xl:flex-row items-stretch xl:items-start py-5"
        >
            <Title
                variant="heading4"
                component={titleComponent}
                weight="semibold"
                className="mb-4 xl:mb-0 xl:w-1/4 xl:mr-8"
                noMargin={true}
            >
                {title}
            </Title>
            <div className="xl:w-3/4">{children}</div>
        </section>
    )
}
